export default [
   { value: "upcoming", label: "Oczekujący" },
   { value: "confirmed", label: "Potwierdzono" },
   { value: "completed", label: "Zakończone" },
   { value: "canceled", label: "Odwołane" }
]